module.exports = __webpack_public_path__ + "static/img/bi_cert.5ca5d19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bi_cert.jpg
// module id = 215
// module chunks = 1